var _line, _g, _line2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankyouHeaderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 49,
    viewBox: "0 0 468 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.0849609,
    y1: 24,
    x2: 200.085,
    y2: 24,
    stroke: "url(#paint0_linear_1046_5140)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_5140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.579 0.5H225.069C227.029 0.504457 228.907 1.28436 230.293 2.66928C231.679 4.0542 232.461 5.93153 232.467 7.89099V22.8808H217.187V7.89099C217.192 5.93226 217.973 4.05545 219.358 2.67058C220.743 1.28571 222.62 0.50535 224.579 0.5Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.085 15.8293V15.3628C210.089 13.4948 210.832 11.7044 212.153 10.383C213.473 9.06166 215.263 8.31688 217.131 8.31152L232.467 22.8805H217.131C215.263 22.8752 213.473 22.1304 212.153 20.809C210.832 19.4877 210.089 17.6973 210.085 15.8293Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.421 0.5H242.929C240.97 0.504903 239.092 1.28501 237.707 2.66988C236.321 4.05475 235.539 5.93182 235.533 7.89099V22.8808H250.814V7.89099C250.808 5.93226 250.027 4.05545 248.642 2.67058C247.257 1.28571 245.38 0.50535 243.421 0.5Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.916 15.8293V15.3628C257.912 13.4945 257.168 11.7038 255.847 10.3824C254.526 9.06102 252.736 8.31643 250.868 8.31152L235.533 22.8805H250.868C252.736 22.8756 254.526 22.131 255.847 20.8096C257.168 19.4882 257.912 17.6976 257.916 15.8293Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.579 48.3347H225.069C227.029 48.3293 228.907 47.5489 230.293 46.1638C231.679 44.7787 232.46 42.9015 232.467 40.942V25.9521H217.187V40.942C217.193 42.9007 217.974 44.7775 219.359 46.1625C220.744 47.5476 222.62 48.3284 224.579 48.3347Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.085 33V33.4699C210.09 35.3373 210.834 37.1269 212.154 38.4475C213.474 39.7681 215.264 40.5124 217.131 40.5178L232.467 25.9521H217.131C215.264 25.9575 213.474 26.7018 212.154 28.0224C210.834 29.3431 210.09 31.1326 210.085 33Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.421 48.3347H242.929C240.97 48.3289 239.093 47.5483 237.707 46.1632C236.321 44.7782 235.54 42.9012 235.533 40.942V25.9521H250.814V40.942C250.808 42.9007 250.027 44.7775 248.642 46.1625C247.257 47.5476 245.38 48.3284 243.421 48.3347Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.916 33V33.4699C257.911 35.3376 257.167 37.1274 255.846 38.4481C254.525 39.7688 252.736 40.5129 250.868 40.5178L235.533 25.9521H250.868C252.736 25.9571 254.525 26.7012 255.846 28.0218C257.167 29.3425 257.911 31.1323 257.916 33Z",
    fill: "#295F98"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 267.916,
    y1: 24,
    x2: 467.916,
    y2: 24,
    stroke: "url(#paint1_linear_1046_5140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1046_5140",
    x1: 0.0849609,
    y1: 25,
    x2: 200.085,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A7FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1046_5140",
    x1: 267.916,
    y1: 25,
    x2: 467.916,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39A7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_5140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.831,
    height: 48,
    fill: "white",
    transform: "translate(210.085 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouHeaderImg);
export default __webpack_public_path__ + "static/media/thankyou-header-img.37558a91c63304e8787a556644f282e3.svg";
export { ForwardRef as ReactComponent };